import { render, staticRenderFns } from "./DashboardPersonal.vue?vue&type=template&id=101fe39a"
import script from "./DashboardPersonal.vue?vue&type=script&lang=js"
export * from "./DashboardPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports